/*eslint-disable array-callback-return */
/*eslint-disable linebreak-style */
/*eslint-disable eqeqeq */
/*eslint-disable no-redeclare */
/*eslint-disable no-unused-vars */
import React, { useEffect } from 'react';
import { Form } from 'react-bootstrap';
import '../Registrationsetup.scss';
import GetAdminConfiguration from '../../../api/GetAdminConfig';

const WaysOfRegistration = (props) => {
  const { onChange, hasEditPermission } = props;
  const { values, errors } = props;
  const { waysOfRegistrationEditable } = props;

  const iIndex = props.iIndex;
  const [state, setState] = React.useState({
    memberID: GetAdminConfiguration.WaysOfReg[iIndex + 1],
    findAccount: GetAdminConfiguration.WaysOfReg[iIndex + 2],
  });

  const { memberID, findAccount } = state;

  const handleChange = (event) => {
    setState({ ...state, [event.target.name]: event.target.checked });
    //console.log(state)
  };

  useEffect(() => {
    GetAdminConfiguration.WaysOfReg[iIndex + 1] = memberID;
    GetAdminConfiguration.WaysOfReg[iIndex + 2] = findAccount;
    console.log(GetAdminConfiguration.WaysOfReg);
    props.handleWaysOfReg(GetAdminConfiguration.WaysOfReg);
  }, [memberID, findAccount]);
  return (
    <div>
      <Form.Group id="formGridmemberIDD">
        <Form.Label for="memberIDs">Use Member ID</Form.Label>
        <Form.Check
          type="checkbox"
          label="Members can locate the Member ID on the front of the ID Card"
          checked={memberID}
          onChange={handleChange}
          id="memberID"
          name="memberID"
          disabled={!waysOfRegistrationEditable || !hasEditPermission}
          isDisabled={!hasEditPermission}
          className={!hasEditPermission && 'disabled-checkbox'}
        />
      </Form.Group>

      <Form.Group id="formGridfindAccount">
        <Form.Label for="findAccount">Use “Find My Account” Option</Form.Label>
        <Form.Check
          type="checkbox"
          label="A form of questions to identify the Member and get him or her registered"
          checked={findAccount}
          onChange={handleChange}
          id="findAccount"
          name="findAccount"
          disabled={!waysOfRegistrationEditable || !hasEditPermission}
          isDisabled={!hasEditPermission}
          className={!hasEditPermission && 'disabled-checkbox'}
        />
      </Form.Group>
    </div>
  );
};

export default WaysOfRegistration;
